import { Spinner } from '@moovly/ui';
import * as React from 'react';
import Panel from '../../../components/Panel';
import { BarChart } from '../../charts';
import { BarChartSet } from '../../charts/components/BarChart';

interface DashboardBardChartCardProps {
  data?: BarChartSet | BarChartSet[];
  title: string;
}

const DashboardBardChartCard: React.FC<DashboardBardChartCardProps> = ({ data, title }) => {
  return <Panel title={title}>{data ? <BarChart data={data} /> : <Spinner />}</Panel>;
};

export default DashboardBardChartCard;
